(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('ngPlaceholder', ngPlaceholder);

    function ngPlaceholder() {
        return {
            restrict: 'A',
            scope: {
                placeholder: '=ngPlaceholder'
            },
            link: function (scope, elem, attr) {
                scope.$watch('placeholder', function () {
                    elem[0].placeholder = scope.placeholder;
                });
            }
        };
    }

})();